module.exports = __webpack_public_path__ + "media/images/badges/yogasix/february/HeartBadges-16-64c133386d81abfe9160ff53fc996a17.png";